import { CWBaseModel } from 'src/core/models/cwBase.model';

export class CWListerEvetGenOverloadedBaseModel extends CWBaseModel {

    public objErrors: { [key: string]: any };
    public nObjErrors: { [key: string]: any };
}
